import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';

// import { GridColumns, GridColDef } from '@material-ui/data-grid';
import { CustomGridColumns } from '~/components/CustomDataGrid/protocols';

// import { tableItensColumns } from '~/pages/EntradaNFE/protocols';
import { tableItensColumns } from '../../tableItensColumns';

import { ScrollButtonsContainer } from './style';

interface ScrollButtonProps extends ButtonProps {
  field: string;
}

const ScrollButton = ({ onClick, field, ...rest }: ScrollButtonProps) => {
  return <Button {...rest} onClick={() => scroll(field)} />;
};

const scroll = (field: string) => {
  const index = tableItensColumns.findIndex(
    (column: CustomGridColumns) => column.field === field,
  );
  const columns = tableItensColumns.slice(0, index);
  let offset = 0;
  columns.map((column: CustomGridColumns) => {
    offset += column.width || 0;
    return column;
  });
  if (offset === 0) {
    document.getElementsByClassName(
      'tableNFOutrasOperacoesContainer',
    )[0].scrollLeft = 0;
    return;
  }
  const tableElement = document.querySelector<HTMLElement>(
    '#tableNFOutrasOperacoes',
  );
  const tableWidth = tableElement?.offsetWidth || 0;
  if (offset >= tableWidth) {
    document.getElementsByClassName(
      'tableNFOutrasOperacoesContainer',
    )[0].scrollLeft = tableWidth;
    return;
  }
  document.getElementsByClassName(
    'tableNFOutrasOperacoesContainer',
  )[0].scrollLeft = offset;
};

const buttons = [
  { field: 'num_item', label: 'Identificador' },
  { field: 'qtd_embalagem', label: 'Quantidade' },
  { field: 'val_desconto', label: 'Variáveis' },
  { field: 'val_bc_icms', label: 'ICMS' },
  { field: 'val_bc_st', label: 'ST' },
  { field: 'per_icms', label: 'Tributação' },
  { field: 'val_frete', label: 'Outros' },
  { field: 'cod_ibs_cbs', label: 'IBS/CBS' },
];

export const ScrollButtons: React.FC = () => {
  return (
    <ScrollButtonsContainer>
      {buttons.map((btn) => (
        <ScrollButton key={btn.field} field={btn.field}>
          {btn.label}
        </ScrollButton>
      ))}
    </ScrollButtonsContainer>
  );
};
